import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const url = qualifyUrl("plugins/org.graylog.plugins.widgetexport/widgetexport");
export const fetchExportData = (exportCallId) => fetch("GET", `${url}/${exportCallId}`).then(
  ({ widget: { widget_type: widgetType, render_type: renderType, ...rest }, data }) => ({
    data,
    widget: {
      widgetType,
      renderType,
      ...rest
    }
  })
);
const useExportData = (exportCallId) => {
  const { data, refetch, isFetching } = useQuery({
    queryKey: ["exported-data", exportCallId],
    queryFn: () => defaultOnError(
      fetchExportData(exportCallId),
      i18n.t("notifications.fetch_export_data_failed", { ns: "enterprise_search" }),
      i18n.t("notifications.fetch_export_data_failed_title", { ns: "enterprise_search" })
    ),
    placeholderData: keepPreviousData,
    enabled: !!exportCallId
  });
  return {
    data,
    refetch,
    isFetching
  };
};
export default useExportData;
